import React from 'react';
import { Row, Col } from 'antd';
import BannerCurveImage from './images/bannerCurve.svg';

const BannerCurve = () => {
    return (
        <div>
            {/* Banner */}
            <Row
                align='middle'
                style={{
                    backgroundColor: '#eef4f5',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    paddingTop: '45px',
                    paddingBottom: '60px',
                    position: 'relative',
                }}
            >
                <Col
                    xs={24}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        transform: 'translateY(-82%)',
                    }}
                >
                    <img
                        src={BannerCurveImage}
                        alt='<app_name>'
                        width='100%'
                        style={{ marginBottom: '-10px' }}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default BannerCurve;
